import AFRAME from "aframe";

AFRAME.registerComponent('sky', {
    init(){
    }
})
